import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { NDtAnchor } from './button';
import { NDT_ANCHOR_HOST, NDT_ANCHOR_INPUTS, NDT_BUTTON_HOST, NDT_BUTTON_INPUTS, NDtButtonBase } from './button-base';

const buttonInputs = [...NDT_ANCHOR_INPUTS, 'extended'];

@Component({
  selector: 'button[ndt-fab]',
  template: '<ng-content></ng-content>',
  inputs: buttonInputs,
  host: {
    ...NDT_BUTTON_HOST,
    '[class.ndt-extended-fab]': 'extended',
  },
  exportAs: 'nDtButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtFabButton extends NDtButtonBase {
  private _extended: boolean;

  get extended(): boolean {
    return this._extended;
  }
  set extended(value: BooleanInput) {
    this._extended = coerceBooleanProperty(value);
  }
}

@Component({
  selector: 'button[ndt-mini-fab]',
  template: '<ng-content></ng-content>',
  inputs: NDT_BUTTON_INPUTS,
  host: NDT_BUTTON_HOST,
  exportAs: 'nDtButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtMiniFabButton extends NDtButtonBase {}

@Component({
  selector: 'a[ndt-fab]',
  template: '<ng-content></ng-content>',
  inputs: buttonInputs,
  host: {
    ...NDT_ANCHOR_HOST,
    '[class.ndt-extended-fab]': 'extended',
  },
  exportAs: 'nDtButton, nDtAnchor',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtFabAnchor extends NDtAnchor {
  private _extended: boolean;

  get extended(): boolean {
    return this._extended;
  }
  set extended(value: BooleanInput) {
    this._extended = coerceBooleanProperty(value);
  }
}

@Component({
  selector: 'a[ndt-mini-fab]',
  template: '<ng-content></ng-content>',
  inputs: NDT_ANCHOR_INPUTS,
  host: NDT_ANCHOR_HOST,
  exportAs: 'nDtButton, nDtAnchor',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtMiniFabAnchor extends NDtAnchor {}
